module.exports = __webpack_public_path__ + "img/matias-selva.542a8fb1.jpg";